import { MainPath, publicPath } from "Constants/constants";

import { Cart } from "Store/cart/cartInterfaces";
import { addDays } from "date-fns";
import cookies from "js-cookie";
import { isPartnerCart } from "../cartUtils";
import { Cookie } from "./cookieTypes";

export const setPageRedirectedFromCookie = (path: string): void => {
  setCookie(Cookie.PAGE_REDIRECTED_FROM, path);
};

export const getPageRedirectedFromCookie = (): string | undefined =>
  cookies.get(Cookie.PAGE_REDIRECTED_FROM);

export const deletePageRedirectFromCookie = (): void => {
  removeCookie(Cookie.PAGE_REDIRECTED_FROM);
};

export function updateCookies(cart: Cart): void {
  setCookie(Cookie.CART_ID, cart.cartId);
  removeCookie(Cookie.GRP);
  if (mustSetCartUriCookie(cart)) {
    setCookie(Cookie.CART_URI, `/${publicPath}/${MainPath.OFFER}`);
  }
  if (cart.products && cart.products.length > 0) {
    setCookie(Cookie.NUMBER_OF_PRODUCTS, `${cart.products.length}`);
    setCookie(Cookie.CART_PRODUCTS, cart.products.map((p) => p.name).join(","));
  } else {
    setEmptyCartCookies();
  }
}

export function setEmptyCartCookies(): void {
  removeCookie(Cookie.CART_ID);
  removeCookie(Cookie.NUMBER_OF_PRODUCTS);
  removeCookie(Cookie.GRP);
}

export const getCartIdFromCookie = (): string | undefined => {
  return cookies.get(Cookie.CART_ID);
};

export const getNumberOfProductsInCartFromCookie = (): string | undefined => {
  return cookies.get(Cookie.NUMBER_OF_PRODUCTS);
};

function setCookie(name: string, value: string): void {
  cookies.set(name, value, {
    path: "/",
    expires: addDays(new Date(), 3),
  });
}

export function removeCookie(name: string): void {
  cookies.remove(name, {
    path: "/",
  });
}

/**
 * Defines when the cartUri cookie must be set by SSX2 to point to SSX2 checkout,
 * to make sure that Navbar sets its cart link correctly.
 */
function mustSetCartUriCookie(cart: Cart): boolean {
  return !isPartnerCart(cart);
}
